"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const TracksType_1 = require("../types/TracksType");
const notInitialized_1 = require("../utils/notInitialized");
class PlayerModel {
    constructor(track, originalTracks) {
        this.track = track;
        this.originalTracks = originalTracks;
        this.onTrackInfoChange = notInitialized_1.notInitialized;
        this.onTrackChange = notInitialized_1.notInitialized;
        this.onTrackListChange = notInitialized_1.notInitialized;
        this.isLoading = false;
        this.tracksType = TracksType_1.TracksType.Tracks;
        this.playlistId = null;
        this.tracks = originalTracks;
    }
}
exports.default = PlayerModel;
